import React, { useState } from "react";
import { Button, Input, message, Modal, Select, Spin, Tooltip } from "antd";
import PharmaAndLabOrderService from "../../Services/PharmaAndLabOrderService";
import medicineImage from "../../../src/assets/images/Svg/addMedicine.svg";
import labReports from "../../../src/assets/images/Svg/addMedicine@.svg";
import MedicineDisabled from "../../../src/assets/images/Svg/MedicineDisabled.svg";
import LabDisabled from "../../../src/assets/images/Svg/LabDisabled.svg";

function ShareOrders({ record }) {
  const [loadingType, setLoadingType] = useState(null);

  const [pharAndLabList, setPharAndLabList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sendPayload, setSendPayload] = useState({});
  const [consultedDrug, setConsultedDrug] = useState([]);

  const showModal = async () => {
    setLoadingType("p");

    let medlistpayload = {
      consultationId: record?.consultationId,
      status: 1,
    };

    let druglist = await PharmaAndLabOrderService.GetDispensedDrugsDtl(
      medlistpayload
    );

    if (Array.isArray(druglist?.data) && druglist.data.length === 0) {
      message.error("Unable to place order, Medicine List is empty");
      setLoadingType("");
      return;
    } else {
      setConsultedDrug(druglist?.data);
    }

    let pharmaListPayload = {
      userId: record.userId,
      status: 1,
    };

    let pharmaList1 = await PharmaAndLabOrderService.GetPharmacyList(
      pharmaListPayload
    );
    setPharAndLabList(pharmaList1.data);
    setIsModalOpen(true);
    setLoadingType(null);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleSelectedItem = (selectedItem) => {
    const filteredList = pharAndLabList.filter(
      (item) => item.id === selectedItem
    );
    setSendPayload(filteredList[0]);
  };

  const [save, setSave] = useState(false);

  const onMedicineOrderSend = async () => {
    setSave(true);
    let LinkPayload = {
      consultationId: record?.consultationId,
      patientId: record.patientId,
      userId: record.userId,
      appointmentId: record.appointmentId,
      prescriptionShareType: "p",
      vendorId: sendPayload.pharmacyId,
      vendorName: sendPayload.pharmacyName,
      vendorMailId: sendPayload.pharmacyMailId,
      vendorMobile: sendPayload.pharmacyMobile,
      drugPrescriptionStatus: "Sent",
      rejectedPharmacyRemarks: null,
      account_Id: record.account_Id,
      clinic_id: record.clinic_Id,
      sourceChannel: "PATIENT",
      branchName: sendPayload.pharmacyBranchName,
      branchId: sendPayload.pharmacyBranchId,
    };

    try {
      const response = await PharmaAndLabOrderService.SharePharmaLabAPI(
        LinkPayload
      );

      if (response.data.message !== "Prescription sent successfully") {
        message.error("Medicine order is already placed");
        setLoadingType(null);
        setSave(false);
        return;
      }
      message.success(`Medicine Order Sent to ${LinkPayload.vendorName}`);
      setSave(false);
    } catch (error) {
      message.error("Medicine order is already placed");
      setSave(false);
    } finally {
      setLoadingType(null);
      setIsModalOpen(false);
      setSave(false);
    }
  };

  const [labList, setLabList] = useState([]);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const [sendPayload2, setSendPayload2] = useState({});
  const [consultedLab, setConsultedLab] = useState([]);

  const showLabModal = async () => {
    setLoadingType("l");

    let labListPayload = {
      consultationId: record.consultationId,
      status: 1,
    };

    let labOrderList = await PharmaAndLabOrderService.GetLabTestOrderDtl(
      labListPayload
    );

    if (Array.isArray(labOrderList?.data) && labOrderList.data.length === 0) {
      message.error("Unable to place order, Lab List is empty");
      setLoadingType("");
      return;
    } else {
      setConsultedLab(labOrderList?.data);
    }

    let labList = {
      userId: record.userId,
      status: 1,
    };

    let labListResult = await PharmaAndLabOrderService.GetLabList(labList);
    setLabList(labListResult.data);
    setIsModalOpen2(true);
    setLoadingType(null);
  };

  const handleLabCancel = () => {
    setIsModalOpen2(false);
  };

  const handleLabSelect = (selectedItem) => {
    const filteredList = labList.filter((item) => item.id === selectedItem);
    setSendPayload2(filteredList[0]);
  };

  const onLabOrderSend = async () => {
    setSave(true);
    let LinkPayload = {
      consultationId: record?.consultationId,
      patientId: record.patientId,
      userId: record.userId,
      appointmentId: record.appointmentId,
      prescriptionShareType: "l",
      vendorId: sendPayload2.labId,
      vendorName: sendPayload2.labName,
      vendorMailId: sendPayload2.labMailId,
      vendorMobile: sendPayload2.labMobile,
      labPrescriptionStatus: "Sent",
      rejectedLabRemarks: null,
      account_Id: record.account_Id,
      clinic_id: record.clinic_Id,
      sourceChannel: "PATIENT",
      branchName: sendPayload2.labBranchName,
      branchId: sendPayload2.labBranchId,
    };

    try {
      const response = await PharmaAndLabOrderService.SharePharmaLabAPI(
        LinkPayload
      );

      if (response.data.message !== "Prescription sent successfully") {
        message.error("Lab order is already placed");
        setIsModalOpen2(false);
        setLoadingType(null);
        setSave(false);
        return;
      }
      message.success(`Lab Order Sent to ${LinkPayload.vendorName}`);
      setSave(false);
    } catch (error) {
      message.error("Lab order is already placed");
    } finally {
      setLoadingType(null);
      setIsModalOpen2(false);
      setSave(false);
    }
  };

  return (
    <>
      {record.transactionId ? (
        <>
          <Tooltip placement="top" title={"Share Medicine Order"}>
            {loadingType === "p" ? (
              <Spin />
            ) : (
              <img
                src={medicineImage}
                alt="Preview"
                className="w-8 h-8"
                role="button"
                // onClick={() => handleOrderShare("p")}
                onClick={showModal}
              />
            )}
          </Tooltip>
          <Tooltip placement="top" title={"Share Lab Diagnostics"}>
            {loadingType === "l" ? (
              <Spin />
            ) : (
              <img
                src={labReports}
                alt="Share"
                className="w-8 h-8"
                role="button"
                // onClick={() => handleLabOrders("l")}
                onClick={showLabModal}
              />
            )}
          </Tooltip>
        </>
      ) : (
        <>
          <Tooltip
            placement="top"
            title={"Payment is not completed on Patient Side"}
          >
            <img
              src={MedicineDisabled}
              alt="Preview"
              className="w-8 h-8 cursor-not-allowed"
              role="button"
            />
          </Tooltip>

          <Tooltip
            placement="top"
            title={"Payment is not completed on Patient Side"}
          >
            <img
              src={LabDisabled}
              alt="Share"
              className="w-8 h-8 cursor-not-allowed"
              role="button"
            />
          </Tooltip>
        </>
      )}
      <Modal
        title={<span className="font-bold text-xl">Medicine Order</span>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[]}
        width={1000}
        height={1000}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}

        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2 text-left">Medicine1</th>
                <th className="border px-4 py-2 text-left">Qty</th>
                <th className="border px-4 py-2 text-left">Dosage</th>
                <th className="border px-4 py-2 text-left">Duration</th>
              </tr>
            </thead>
            <tbody>
              {consultedDrug.map((medicine, index) => (
                <tr key={index}>
                  <td className="border px-2 py-2">{medicine.drugName}</td>
                  <td className="border px-2 py-2">{medicine.quantity}</td>
                  <td className="border px-2 py-2">{medicine.dosage}</td>
                  <td className="border px-2 py-2">{medicine.duration}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-10 gap-2">
          <span className="font-bold text-xl"> Select Pharmacy :</span>
          <Select
            className="w-[40%]"
            onChange={(selectedItem) => {
              handleSelectedItem(selectedItem);
            }}
          >
            {pharAndLabList?.map((pAndlList) => (
              <Select.Option key={pAndlList.id} value={pAndlList.id}>
                {pAndlList.pharmacyName}
              </Select.Option>
            ))}
          </Select>
          {/* <Select className="w-[80%]">
            {pharAndLabList?.map((pAndlList) => (
              <Select.Option key={pAndlList.id} value={pAndlList.pharmacyName}>
                {pAndlList.pharmacyName}
              </Select.Option>
            ))}
          </Select> */}
          <button
            onClick={onMedicineOrderSend}
            className="p-1 rounded-md bg-[#189FAA] text-white font-semibold"
            disabled={save}
          >
            Send Order
          </button>
        </div>
      </Modal>

      <Modal
        title={<span className="font-bold text-xl">Lab Order</span>}
        open={isModalOpen2}
        onCancel={handleLabCancel}
        footer={[]}
      >
        {save && (
          <div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="spinner"></div>
          </div>
        )}
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="bg-gray-200">
                <th className="border px-4 py-2 text-center">Test Name</th>
              </tr>
            </thead>
            <tbody>
              {consultedLab.map((lab, index) => (
                <tr key={index}>
                  <td className="border px-2 py-2 text-center">
                    {lab.labTestName}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="flex justify-end mt-10 gap-2">
          <span className="font-bold text-xl"> Select Lab :</span>
          <Select
            className="w-[40%]"
            onChange={(selectedItem) => {
              handleLabSelect(selectedItem);
            }}
          >
            {labList?.map((lab) => (
              <Select.Option key={lab.id} value={lab.id}>
                {lab.labName}
              </Select.Option>
            ))}
          </Select>

          <button
            onClick={onLabOrderSend}
            className="p-1 rounded-md bg-[#189FAA] text-white font-semibold"
            disabled={save}
          >
            Send Order
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ShareOrders;
